import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-day",
  templateUrl: "./med-icon-view-day.component.html",
})
export class MedIconViewDayComponent extends SvgMixinComponent {}
